export default __webpack_public_path__ + "static/media/breakfast.11b6fbc2.svg";